import type { EditorView } from "@tiptap/pm/view";

export function handleComposerKeyDown(view: EditorView, event: KeyboardEvent, submit: (text: string) => void): boolean {
  if (event.key !== "Enter") return false;
  if (event.shiftKey) return false;
  if (event.isComposing) return false;
  event.preventDefault();
  const text = view.state.doc.textContent;
  if (!text.trim()) return true;
  submit(text);
  view.dispatch(view.state.tr.delete(0, view.state.doc.content.size).setMeta("addToHistory", false));
  return true;
}

export function stripPastedHTML(html: string): string {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  const text = tmp.textContent ?? "";
  return `<p>${text}</p>`;
}
